<template>
  <div>
    <template v-for="(productData, productIndex) in data">
      <template
        v-for="(field, fieldIndex) in config.componentOptions.fields"
      >
        <div
          :style="{'display': field.decoratorOptions && field.decoratorOptions.styleHints.includes('show-label') ? 'inline-block' : 'inline'}">
          <span v-if="field.decoratorOptions && field.decoratorOptions.styleHints.includes('show-label')">
            {{ field.label }}:
          </span>
          <component
            :is="`tablefield-${field.decorator}`"
            :key="`${productIndex}--${fieldIndex}`"
            :config="field"
            :data="getCellData(field, productData, 0)"
            :product="productData"
            :style="field.newline ? '' :'display: inline'"
          ></component>
        </div>
        <template
          v-if="fieldIndex + 1 < config.componentOptions.fields.length"
        >
          {{ config.componentOptions.fieldSeparator }}
        </template>
      </template>
      <hr
        v-if="productIndex + 1 < data.length"
        style="margin: 5px 0"
      >
    </template>
  </div>
</template>

<script>
import TablefieldText from './FieldText.vue'
import TablefieldBoolean from './FieldBoolean.vue'
import TablefieldPercent from './FieldPercent.vue'
import TablefieldComposite from './FieldComposite.vue'
import TablefieldDate from './FieldDate.vue'
import TablefieldDateRange from './FieldDateRange.vue'
import TablefieldDecimal from "./FieldDecimal";
import TablefieldCurrency from "./FieldCurrency";
import TablefieldComponent from "./FieldComponent";
import TablefieldTexts from "./FieldTexts";

export default {
  name: 'tablefield-combined-multi-row',
  components: {
    TablefieldText,
    TablefieldBoolean,
    TablefieldPercent,
    TablefieldComposite,
    TablefieldDate,
    TablefieldDateRange,
    TablefieldDecimal,
    TablefieldCurrency,
    TablefieldComponent,
    TablefieldTexts
  },
  props: ['data', 'config', 'product'],
  methods: {
    getCellData(column, product, multiRowIndex) {
      if (column.commentsPath) {
        return this._.get(this.product, `${column.commentsPath}[${product.dq}]`)
      } else {
        let path = column.path ? column.path.replace('[]', `[${multiRowIndex}]`) : ''
        return this._.get(product, path, undefined)
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// FieldCombinedMultirow.vue?f9addc60